import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaPhone } from 'react-icons/fa';

import { fontSize } from '../../../utils';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  align-self: center;
  margin: 0.25rem 0;
  width: 100%;
`;

const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0.5rem 0.75rem;
  border-radius: 2rem;
  background: rgba(228, 220, 248, 0.2);
  width: 100%;
`;

const CallIcon = styled(FaPhone)`
  font-size: ${fontSize(0.75)};
  margin-right: 0.625rem;
  transform: rotate(90deg);
`;

const MessageText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #413958;
`;

const VoiceCallMessage = ({ message }) => (
  <OuterContainer>
    <BubbleContainer>
      <CallIcon />
      <MessageText>{message}</MessageText>
    </BubbleContainer>
  </OuterContainer>
);

VoiceCallMessage.propTypes = {
  message: PropTypes.string,
};

export default VoiceCallMessage;
